import Error from 'components/alerts/Error'
import Success from 'components/alerts/Success'
import { Card } from 'components/common/card/Card';
import { Info } from 'components/common/form/modules/Info';
import { Select } from 'components/common/form/modules/input/Select';
import { Text } from 'components/common/form/modules/input/Text';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { TimezoneSelect } from 'components/common/form/modules/input/TimezoneSelect';
import OnlyAdmin from 'components/guards/OnlyAdmin';
import { RolesSystem, RolesSystemReverse } from 'lib/enums/RolesSystem.enum';
import moment from 'moment';
import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import Moment from 'react-moment';
import { Prompt, Redirect } from 'react-router';
import Switch from 'react-switch'
import { Col, FormText, Label, Row } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';


import { NumberInput } from '../../../../../components/common/form/modules/input/Number';
import { openDeleteEventModal } from '../../../../../components/platform/card/methods';
import ImageUpload from '../../../../../components/upload/ImageUpload';

import ImportEvent from './ImportEvent'
import PublicTicketInventoryTab from './ticketInventory/GeneralTicketInventoryTab';
import PrivateTicketInventoryTab from './ticketInventory/PromoterTicketInventoryTab';
import ReferralTicketInventory from './ticketInventory/ReferralTicketInventory';

import 'react-datepicker/dist/react-datepicker.css';



interface IEditEventFormProps {
  event: any;
  ticketInventory: any;
  users: any[];
  user: any;
  saveSuccessDetail: boolean;
  saveSuccessConfig: boolean;
  tabName: string;
  onSave: (data: any, logo?: boolean) => void;
  onAddUsers: (data: any) => void;
  onChangeUserRole: (userId: string, roleId: string) => void;
  handleAddCodes: (data: any) => void,
  history?: any;
}

export class EditEventForm extends PureComponent<
  IEditEventFormProps,
  { [label: string]: any }
  > {
  constructor(props) {
    super(props);
    // OnContruct state vals
    this.state = {
      event: {
        ...props.event,
        startTime: moment(props.event.startTime) || moment(new Date()), // Only temporary as the page loads
        endTime: moment(props.event.endTime) || moment(new Date()), // Only temporary as the page loads
        onSale: props.event.onSale === false ? false : true,
        styling: {
          promoImg: props.event.styling.promoImg || null,
          bgImg: props.event.styling.bgImg || null,
          descripImg: props.event.styling.descripImg || null
        },
        ticketsURL: props.event.ticketsURL || [],
        time: {
          startYear: 2019,
          startMonth: 1,
          startDay: 1,
          startHour: 12,
          startMinutes: 0,
          startAMPM: true,
          endYear: 2019,
          endMonth: 1,
          endDay: 1,
          endHour: 1,
          endMinutes: 0,
          endAMPM: true
        }
      },
      urlObject: {
        code: '',
        customSubdomain: '',
        teamMap: [{
          userId: '', index: ''
        }]
      },
      messageToTeam: '',
      messageToPotentialBuyers: '',
      messageToBuyers: '',
      messageToReferralLinkUsers: '',
      invalidTeamFormatError: false,
      timeError: false,
      newUser: {
        emails: "",
        role: "5c1b6105b1d7b1343e2ee9ba"
      },
      hostName: props.event.hostName || "",
      isChanged: false,
      teamMember: {
        id: "",
        name: ""
      },
      timeValidationError: false,
      remainingPDFs: props.event.ticketsURL.length || 0,
      isValid: true,
      redirect: false,
      change: false,
      isUploadFinished: false,
      saveSuccessDetail: this.props.saveSuccessDetail,
      saveSuccessConfig: this.props.saveSuccessConfig,
      startTime: new Date(),
      emailSuccess0: false,
      emailError0: false,
      emailSuccess1: false,
      emailError1: false,
      emailSuccess2: false,
      emailError2: false,
      emailSuccess3: false,
      emailError3: false,
      loading: true
    };

    // Handlers...
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFeesChange = this.handleInputFeesChange.bind(this);
    this.handleInputBooleanChange = this.handleInputBooleanChange.bind(this);
    this.handleInputConfigurationsChange = this.handleInputConfigurationsChange.bind(this);
    this.handleTeamNewUserChange = this.handleTeamNewUserChange.bind(this);
    this.handleAddUsers = this.handleAddUsers.bind(this);
    this.handleChangeUserRole = this.handleChangeUserRole.bind(this);
    this.handleChangeTeamMember = this.handleChangeTeamMember.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
    this.handleDateInputChange = this.handleDateInputChange.bind(this);
    this.handleAMPMInputChange = this.handleAMPMInputChange.bind(this);
    this.handleInputChangeLocation = this.handleInputChangeLocation.bind(this);
    this.changeSale = this.changeSale.bind(this);
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
    this.validEmailFormat = this.validEmailFormat.bind(this);
    this.teamMessageChange = this.teamMessageChange.bind(this);
    this.sendMessagetoTeam = this.sendMessagetoTeam.bind(this);
    this.sendMessagetoBuyers = this.sendMessagetoBuyers.bind(this);
    this.sendMessagetoPotentialBuyers = this.sendMessagetoPotentialBuyers.bind(this);
    this.getTeamUsers = this.getTeamUsers.bind(this);
    this.getTotalAllocated = this.getTotalAllocated.bind(this);
    this.sendReferralLinksWithAMessage = this.sendReferralLinksWithAMessage.bind(this);
    this.handleAddCodes = this.handleAddCodes.bind(this);
  }

  public componentDidMount() {
    fetchGraphQL(
      `
      query {
        time {
          findByEventId(id:"${this.props.event.id}") {
            startYear
            startMonth
            startDay
            startHour
            startMinutes
            startAMPM
            endYear
            endMonth
            endDay
            endHour
            endMinutes
            endAMPM
          }
        }
      }
      `).then((time => {
        fetchGraphQL(`
        query {
          url {
            get(eventId: "${this.props.event.id}") {
              code
              customSubdomain
              teamMap {
                userId
                index
              }
            }
          }
        }
        `).then(res => {
          // console.log(res.url.get)
          this.setState({
            urlObject: res.url.get || {
              code: '',
              customSubdomain: '',
              teamMap: [{
                userId: '', index: ''
              }]
            },
            loading: false
          })
          const t = time.time.findByEventId;
          const startTime = new Date(t.startYear, t.startMonth - 1, t.startDay, t.startAMPM ? t.startHour + 12 : t.startHour, t.startMinutes)
          const endTime = new Date(t.endYear, t.endMonth - 1, t.endDay, t.endAMPM ? t.endHour + 12 : t.endHour, t.endMinutes)
          this.setState({
            event: {
              ...this.state.event,
              time: t
            },
            startTime,
            endTime
          })
        })
      }))
  }

  public handleStartChange(e) {
    if (e > this.state.endTime) {
      this.setState({
        event: {
          ...this.state.event,
          time: {
            ...this.state.event.time,
            startYear: e.getFullYear(),
            startMonth: e.getMonth() + 1,
            startDay: e.getDate(),
            startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            startMinutes: e.getMinutes(),
            startAMPM: e.getHours() > 12 ? true : false,
            endYear: e.getFullYear(),
            endMonth: e.getMonth() + 1,
            endDay: e.getDate(),
            endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            endMinutes: e.getMinutes(),
            endAMPM: e.getHours() > 12 ? true : false
          }
        },
        startTime: e,
        endTime: e
      })
      return;
    }

    this.setState({
      event: {
        ...this.state.event,
        time: {
          ...this.state.event.time,
          startYear: e.getFullYear(),
          startMonth: e.getMonth() + 1,
          startDay: e.getDate(),
          startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
          startMinutes: e.getMinutes(),
          startAMPM: e.getHours() > 12 ? true : false
        }
      },
      startTime: e
    })
  }

  public handleEndChange(e) {

    if (e < this.state.startTime) {
      this.setState({
        event: {
          ...this.state.event,
          time: {
            ...this.state.event.time,
            startYear: e.getFullYear(),
            startMonth: e.getMonth() + 1,
            startDay: e.getDate(),
            startHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            startMinutes: e.getMinutes(),
            startAMPM: e.getHours() > 12 ? true : false,
            endYear: e.getFullYear(),
            endMonth: e.getMonth() + 1,
            endDay: e.getDate(),
            endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
            endMinutes: e.getMinutes(),
            endAMPM: e.getHours() > 12 ? true : false
          }
        },
        startTime: e,
        endTime: e
      })
      return;
    }

    this.setState({
      event: {
        ...this.state.event,
        time: {
          ...this.state.event.time,
          endYear: e.getFullYear(),
          endMonth: e.getMonth() + 1,
          endDay: e.getDate(),
          endHour: e.getHours() > 12 ? e.getHours() - 12 : e.getHours(),
          endMinutes: e.getMinutes(),
          endAMPM: e.getHours() > 12 ? true : false
        }
      },
      endTime: e
    })
  }

  public changeSale() {
    this.setState({
      event: {
        ...this.state.event,
        onSale: !this.state.event.onSale
      }
    }, () => {
      this.props.onSave(this.state.event);
    })

  }

  public handleInputChangeLocation(e: any) {
    this.setState(
      {
        event: {
          ...this.state.event,
          location: e.description
        },
        isChanged: true
      }
    );
  }

  public validEmailFormat() {
    const stringArray = this.state.newUser.emails.split('\n');
    let error = false
    const emails: string[] = []

    stringArray.map(item => {
      const email = item.trim();
      if (email !== null
        && email !== undefined
        && email !== ""
        && email.length !== 0
        && !emails.includes(email)
        && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emails.push(email)
      } else {
        error = true;
      }
    })
    return error;
  }

  public handleAddUsers(e: any) {
    if (this.validEmailFormat()) {
      this.setState({ invalidTeamFormatError: true })
    } else {
      this.props.onAddUsers(this.state.newUser);
    }
  }

  public handleAddCodes(e: any) {
    // console.log(this.state.newUser)
    this.props.handleAddCodes(this.state.newUser)
  }

  public handleTeamNewUserChange(e: any) {
    const { name, value } = e.target;
    this.setState({
      newUser: {
        ...this.state.newUser,
        [name]: value
      },
      isChanged: true,
      invalidTeamFormatError: false
    });
  }

  public teamMessageChange(e: any, type: string) {
    switch (type) {
      case 'team':
        this.setState({
          messageToTeam: e.target.value,
          emailError0: false,
          emailSuccess0: false
        })
        break;
      case 'buyers':
        this.setState({
          messageToBuyers: e.target.value,
          emailError1: false,
          emailSuccess1: false
        })
        break;
      case 'potentialBuyers':
        this.setState({
          messageToPotentialBuyers: e.target.value,
          emailError2: false,
          emailSuccess2: false
        })
        break;
      case 'referralLinkUsers':
        this.setState({
          messageToReferralLinkUsers: e.target.value,
          emailError3: false,
          emailSuccess3: false
        })
    }
  }

  public sendMessagetoTeam() {
    fetchGraphQL(`
    mutation {
      event {
        sendMessageToTeam(message:"""${this.state.messageToTeam}""",eventId:"${this.props.event.id}")
      }
    }
    `).then(res => {
      if (res.event.sendMessageToTeam === true) {
        this.setState({
          emailSuccess0: true, emailError0: false
        })
      } else {
        this.setState({
          emailSuccess0: false, emailError0: true
        })
      }
    })
  }

  public sendMessagetoBuyers() {
    fetchGraphQL(`
    mutation {
      event {
        sendMessageToBuyers(message:"""${this.state.messageToBuyers}""",eventId:"${this.props.event.id}")
      }
    }
    `).then(res => {
      if (res.event.sendMessageToBuyers === true) {
        this.setState({
          emailSuccess1: true, emailError1: false
        })
      } else {
        this.setState({
          emailSuccess1: false, emailError1: true
        })
      }
    })
  }

  public sendMessagetoPotentialBuyers() {
    fetchGraphQL(`
    mutation {
      event {
        sendMessageToPotentialBuyers(message:"""${this.state.messageToPotentialBuyers}""",eventId:"${this.props.event.id}")
      }
    }
    `).then(res => {
      if (res.event.sendMessageToPotentialBuyers === true) {
        this.setState({
          emailSuccess2: true, emailError2: false
        })
      } else {
        this.setState({
          emailSuccess2: false, emailError2: true
        })
      }
    })
  }

  public sendReferralLinksWithAMessage() {
    fetchGraphQL(`
    mutation {
      event {
        sendMessageToReferralLinkUsers(message:"""${this.state.messageToReferralLinkUsers}""",eventId:"${this.props.event.id}")
      }
    }
    `).then(res => {
      if (res.event.sendMessageToReferralLinkUsers === true) {
        this.setState({
          emailSuccess3: true, emailError3: false
        })
      } else {
        this.setState({
          emailSuccess3: false, emailError3: true
        })
      }
    })
  }

  public handleChangeTeamMember(e: any) {
    const { value } = e.target;
    this.setState({
      teamMember: {
        id: value
      },
      isChanged: true
    });
  }

  public handleDateInputChange(e: any) {
    const { name, value } = e.target;
    this.setState(
      {
        event: {
          ...this.state.event,
          time: {
            ...this.state.event.time,
            [name]: Number(value)
          }
        },
        isChanged: true
      }
    );
  }

  public handleAMPMInputChange(e: any) {
    const { name, value } = e.target;
    if (value === "0") {
      this.setState(
        {
          event: {
            ...this.state.event,
            time: {
              ...this.state.event.time,
              [name]: false
            }
          },
          isChanged: true
        }
      );
    } else {
      this.setState(
        {
          event: {
            ...this.state.event,
            time: {
              ...this.state.event.time,
              [name]: true
            }
          },
          isChanged: true
        }
      );
    }
  }

  public handleInputChange(e: any) {
    const { name, value } = e.target;
    this.setState({
      event: {
        ...this.state.event,
        [name]: value
      },
      isChanged: true,
      saveSuccessConfig: false,
      saveSuccessDetail: false
    });
  }

  public handleInputFeesChange(e: any) {
    const { name } = e.target;
    let { value } = e.target;
    value = Number(value);

    if (this.state.event.fees[name] != null) {
      this.setState({
        event: {
          ...this.state.event,
          fees: {
            ...this.state.event.fees,
            [name]: value
          }
        },
        saveSuccessConfig: false,
        saveSuccessDetail: false
      })
    }
  }

  public handleRedirect() {
    this.setState({ ...this.state, redirect: true })
  }

  public handleInputBooleanChange(e: any) {
    const { name, value } = e.target;
    if (value === "pass") {
      this.setState({
        event: {
          ...this.state.event,
          fees: {
            ...this.state.event.fees,
            [name]: false
          }
        },
        saveSuccessConfig: false,
        saveSuccessDetail: false
      })
    } else {
      this.setState({
        event: {
          ...this.state.event,
          fees: {
            ...this.state.event.fees,
            [name]: true
          }
        },
        saveSuccessConfig: false,
        saveSuccessDetail: false
      })
    }
  }

  public handleInputConfigurationsChange(e: any) {
    const { name, value } = e.target;
    if (name === 'maxTicketsPerOrder') {
      this.setState({
        event: {
          ...this.state.event,
          configuration: {
            ...this.state.event.configuration,
            [name]: value,
            maxTicketsPerType: value
          }
        },
        saveSuccessConfig: false,
        saveSuccessDetail: false
      });
    } else {
      this.setState({
        event: {
          ...this.state.event,
          configuration: {
            ...this.state.event.configuration,
            [name]: value
          }
        },
        saveSuccessConfig: false,
        saveSuccessDetail: false
      });
    }
    const totalAllocated = this.getTotalAllocated();
    if (name === "quota" && Number(value) < totalAllocated) {
      this.setState({
        isValid: false
      });
    }
    else {
      this.setState({
        isValid: true
      });
    }
  }


  public handleChangeUserRole(userId: string, roleId: string) {
    this.props.onChangeUserRole(userId, roleId);
  }


  public getTotalAllocated() {
    let totalAllocatedTicket = 0;
    this.props.ticketInventory.forEach((titem: any) => {
      if (titem.quantity !== -1) {
        totalAllocatedTicket += (titem.quantity);
      } else {
        totalAllocatedTicket += (titem.bought + titem.activated)
      }
    });
    return totalAllocatedTicket;
  }

  public renderDetailsTab() {

    if (this.state.startTime === undefined || this.state.endTime === undefined) {
      return null;
    }

    const now = new Date()
    now.setHours(23)
    now.setMinutes(45)

    const zero = new Date()
    zero.setHours(0);
    zero.setMinutes(0);

    let flag1 = false;
    let flag2 = false;
    const today = new Date();

    if (this.state.startTime.getFullYear() === today.getFullYear()) {
      if (this.state.startTime.getMonth() === today.getMonth()) {
        if (this.state.startTime.getDate() === today.getDate()) {
          flag1 = true;
        }
      }
    }
    if (this.state.endTime.getFullYear() === today.getFullYear()) {
      if (this.state.endTime.getMonth() === today.getMonth()) {
        if (this.state.endTime.getDate() === today.getDate()) {
          flag2 = true;
        }
      }
    }

    const redirect = this.state.redirect === true ? <Redirect to='/manage/events' /> : null;
    return (
      <div>
        <div>
          <div>
            {redirect}
          </div>
          <div className="big-split-768">
            <Row>
              <Col>
                <Card>
                  <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                    <p />
                    <div style={{ textAlign: 'center' }}>
                      <div>
                        <h3 className="sexyBlack">Basic Information</h3>
                      </div>
                      <div >
                        <p />
                        <ImportEvent eventId={this.props.event.id} />
                      </div>
                    </div>
                    <p />
                    <Text
                      label="Name of event"
                      value={this.state.event.name}
                      name="name"
                      onChange={this.handleInputChange}
                    />
                    <Text
                      label="Host name"
                      value={this.state.event.hostName}
                      name="hostName"
                      onChange={this.handleInputChange}
                    />
                    <div>
                      <Label>
                        Location
                    </Label>
                      <GooglePlacesAutocomplete
                        onSelect={this.handleInputChangeLocation}
                        initialValue={this.state.event.location}
                        placeholder=''
                        inputStyle={{
                          width: '100%',
                          borderRadius: '10px',
                          border: '1px solid #CED4DA',
                          boxShadow: 'none',
                          color: '#495057'
                        }}
                      />
                      <p />
                    </div>
                    <TextArea
                      label="Description"
                      value={this.state.event.description}
                      name="description"
                      onChange={this.handleInputChange}
                    />
                    <p />
                    {
                      this.props.event.isActive === true ?
                        <div>
                          <div style={{ textAlign: 'center', width: '100%' }}>
                            <br />
                            <div>
                              <div style={{ height: '30px', lineHeight: '40px' }}>
                                <Switch
                                  checked={this.state.event.onSale}
                                  onChange={this.changeSale}
                                  onColor="#4d5adf"
                                  onHandleColor="#ffffff"
                                  handleDiameter={25}
                                  uncheckedIcon={false}
                                  checkedIcon={true}
                                  boxShadow="0 2px 1px -1px gray"
                                  height={25}
                                  width={50}
                                  className="react-switch"
                                  id="material-switch"
                                />
                              </div>
                              <div style={{ height: '20px', lineHeight: '20px' }}>Live</div>
                            </div>
                            <FormText color="muted">Event goes on sale if turned on.</FormText>
                          </div>
                          <p />
                        </div> : null
                    }
                  </div>
                  <p />
                </Card>
                {
                  this.props.event.payoutTime === null ?
                    <div>
                      <p><br /></p>
                      <Card>
                        <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                          <p />
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            <h3 className="sexyBlack">Time Information</h3>
                          </div>
                          <p />
                          <div>
                            <div>
                              <div className="big-split-768">
                                <div style={{ textAlign: 'center' }}>
                                  <div style={{ width: '50%', float: 'left' }}>
                                    <p>Start Time</p>
                                    <DatePicker
                                      selected={this.state.startTime}
                                      onChange={this.handleStartChange}
                                      selectsStart={true}
                                      startDate={this.state.startTime}
                                      endDate={this.state.endTime}
                                      minDate={new Date()}

                                      minTime={flag1 ? new Date() : zero}
                                      maxTime={now}

                                      showTimeSelect={true}
                                      timeFormat="HH:mm"
                                      timeIntervals={15}
                                      dateFormat="MMMM d, yyyy h:mm aa"
                                      timeCaption="time"
                                      style={{ width: '100%' }}
                                    />
                                    <p />
                                  </div>
                                  <div style={{ width: '50%', float: 'right' }}>
                                    <p>End Time</p>
                                    <DatePicker
                                      selected={this.state.endTime}
                                      onChange={this.handleEndChange}
                                      selectsEnd={true}
                                      startDate={this.state.startTime}
                                      endDate={this.state.endTime}
                                      minDate={this.state.startTime}

                                      minTime={flag2 ? new Date() : zero}
                                      maxTime={now}

                                      showTimeSelect={true}
                                      timeFormat="HH:mm"
                                      timeIntervals={15}
                                      dateFormat="MMMM d, yyyy h:mm aa"
                                      timeCaption="time"
                                      style={{ width: '100%' }}
                                    />
                                    <p />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style={{ paddingLeft: '10%', paddingRight: '10%', paddingTop: '25px' }}>
                              <p><br /></p>
                              <TimezoneSelect
                                onChange={this.handleInputChange}
                                name="timezoneOffset"
                                value={this.state.event.timezoneOffset}
                                label="Time zone"
                                infoMessage={"Event will no longer be active once it reaches its end time in its time zone."}
                              />
                            </div>
                          </div>
                        </div>
                        <p><br /></p>
                      </Card>
                    </div> : null
                }
                {/* {
                  screen.width <= 768 ? null :
                    <div>
                      <p><br /></p>
                      <Card style={{ textAlign: 'center', paddingRight: '10%', paddingLeft: '10%' }}>
                        <div>
                          <p />
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            <h3 className="sexyBlack">Import Third-Party Tickets</h3><div className="sexyBlack">(Optional)</div>
                          </div>
                          <p />
                          {
                            this.state.remainingPDFs !== 0 ? <h5>Available imported tickets:  <b>{this.state.remainingPDFs}</b><br /></h5> : null
                          }
                          <Info>
                            If your venue only accepts certain third-party tickets, import your venue’s tickets here.<br />
                            Click “Choose Files” and select PDF ticket files for upload. (Recommended file size: ~300KB/file).
                            Each PDF ticket file is only valid for one ticket. You may upload as many files as you want. <br />
                            Then, click “Upload tickets” and wait for the successful upload notification. <br />
                            The Isotope e-mail receipt includes the PDF ticket files as attachments.<br />
                          </Info>
                          <TicketsUpload
                            ticketsLoc={this.state.event.name.replace(/ /g, "_") + "-" + this.state.event.id}
                            onUpload={pdfUrls => {
                              this.setState({
                                event: {
                                  ...this.state.event,
                                  ticketsURL: [...this.state.event.ticketsURL, ...pdfUrls]
                                }
                              });
                              this.props.onSave(this.state.event);
                            }}
                          />

                          <p><br /><hr /></p>

                          <Select
                            label="Free tickets exclusion"
                            value={this.state.event.configuration.excludeFree == null || this.state.event.configuration.excludeFree === false ? "false" : "true"}
                            name="excludeFree"
                            onChange={(e: any) => {
                              this.setState({
                                event: {
                                  ...this.state.event,
                                  configuration: {
                                    ...this.state.event.configuration,
                                    [e.target.name]: e.target.value === "true" ? true : false
                                  }
                                }
                              },
                                () => {
                                  this.props.onSave(this.state.event);
                                }
                              );
                            }}
                            infoMessage={
                              "If you select “Exclude,” those who purchase free tickets will not receive third-party tickets in their receipt."
                            }
                          >
                            <option value="true">Exclude free tickets</option>
                            <option value="false">Include free tickets</option>
                          </Select>
                        </div>
                        <p>
                          <br />
                        </p>
                      </Card>
                    </div>
                } */}
                <p><br /></p>
                <Card>
                  <div style={{ paddingRight: '15%', paddingLeft: '15%' }}>
                    <p />
                    <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Quotas and Fees</h3>
                    <p />
                    <NumberInput
                      label="Total event quota"
                      infoMessage={
                        "The total number of existing tickets – allocated, offers pending and sold – will not exceed the event quota."
                      }
                      value={this.state.event.configuration === null ? this.getTotalAllocated() : this.state.event.configuration.quota}
                      min={this.getTotalAllocated()}
                      name="quota"
                      onChange={this.handleInputConfigurationsChange}
                    />

                    <NumberInput
                      label="Tax (%)"
                      value={this.state.event.fees == null ? 0 : this.state.event.fees.taxPercentage}
                      min={0}
                      max={100}
                      name="taxPercentage"
                      onChange={this.handleInputFeesChange}
                    />

                    <NumberInput
                      label="Max tickets per order"
                      value={this.state.event.configuration === null ? 1 : this.state.event.configuration.maxTicketsPerOrder}
                      min={-1}
                      name="maxTicketsPerOrder"
                      onChange={this.handleInputConfigurationsChange}
                    />

                    <Select
                      label="Service fee attribution"
                      value={this.state.event.fees.absorb ? "absorb" : "pass"}
                      name="absorb"
                      onChange={this.handleInputBooleanChange}
                      infoMessage={
                        "Passed-on fees are added to the base ticket price for customers to bear. Absorbed fees keep the same base ticket price, but fees are deducted from event revenue.\n*Card processing fees will be added."
                      }
                    >

                      <option value="pass">Pass fees on</option>
                      <option value="absorb">Absorb fees</option>

                    </Select>
                    <OnlyAdmin>
                      <p><br /><br /></p>
                      <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Service Fee</h3>
                      <p />
                      <NumberInput
                        label="Service fee per Ticket ($)"
                        value={this.state.event.fees == null ? 1 : (this.state.event.fees.perTicketFee)}
                        min={0}
                        name="perTicketFee"
                        onChange={this.handleInputFeesChange}
                      />
                      <NumberInput
                        label="Service fee per Order (%)"
                        value={this.state.event.fees == null ? 0 : this.state.event.fees.perOrderFee}
                        min={0}
                        name="perOrderFee"
                        onChange={this.handleInputFeesChange}
                      />
                      <p />
                    </OnlyAdmin>
                    <p />
                    <div className="align-center" style={{ width: "100%" }}>
                      {this.state.saveSuccessConfig ? <Success content="Settings saved successfully!" /> : null}
                      {!this.state.isValid ? (
                        <div className='alert alert-danger'>
                          Event quota must be greater than or equal to the total number of allocated tickets ({this.getTotalAllocated()})
                        </div>
                      ) : (
                          null
                        )}
                    </div>

                  </div>
                </Card>
                <p><br /></p>
              </Col>
              <Col>
                {
                  screen.width <= 768 ? null :
                    <div>
                      <Card>
                        <div style={{ paddingRight: '10%', paddingLeft: '5%', textAlign: 'center' }}>
                          <p />
                          <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Cover Image</h3>
                          <Info>Customers will see this image on the checkout page for this event.<br />Recommended image size: 1000px x 400px.<br />Image size limit: 1MB.</Info>
                          <div style={{ paddingRight: '15%', paddingLeft: '15%' }}>
                            <ImageUpload
                              imgSrc={this.state.event.styling.promoImg}
                              onUpload={imgUrl => {
                                this.setState({
                                  event: {
                                    ...this.state.event,
                                    styling: {
                                      ...this.state.event.styling,
                                      promoImg: imgUrl
                                    }
                                  }
                                });
                                this.props.onSave(this.state.event);
                              }}
                            />
                            {
                              this.state.event.styling.promoImg !== null && this.state.event.styling.promoImg !== "" ?
                                <div style={{ width: '100%', float: 'right' }}>
                                  <p />
                                  <button className="new-button-white-4" onClick={e => {
                                    this.setState({
                                      event: {
                                        ...this.state.event,
                                        styling: {
                                          ...this.state.event.styling,
                                          promoImg: null
                                        }
                                      }
                                    }, () => {
                                      this.props.onSave(this.state.event)
                                    })
                                  }}
                                    style={{ color: '#FF5244' }}
                                  >
                                    REMOVE
                                  </button>
                                </div> : null
                            }
                          </div>
                        </div>
                        <p><br /></p>
                      </Card>
                      <p><br /></p>
                      <Card>
                        <div style={{ paddingRight: '10%', paddingLeft: '5%', textAlign: 'center' }}>
                          <p />
                          <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>White-Label Event Logo</h3>
                          <Info>Replace the Isotope logo with your own for this event.<br />
                            Uploaded logo should be a PNG with a transparent background.<br /><br />
                            Recommended image size: 300px width x 150px height. <br />Image size limit: 1MB.</Info>
                          <div style={{ paddingRight: '15%', paddingLeft: '15%' }}>
                            <ImageUpload
                              imgSrc={this.state.event.styling.bgImg}
                              onUpload={imgUrl => {
                                this.setState({
                                  event: {
                                    ...this.state.event,
                                    styling: {
                                      ...this.state.event.styling,
                                      bgImg: imgUrl
                                    }
                                  }
                                });
                                this.props.onSave(this.state.event, true)
                              }}
                              logo={true}
                            />
                            {
                              this.state.event.styling.bgImg !== null && this.state.event.styling.bgImg !== "" ?
                                <div style={{ width: '100%', float: 'right' }}>
                                  <p />
                                  <button className="new-button-white-4" onClick={e => {
                                    this.setState({
                                      event: {
                                        ...this.state.event,
                                        styling: {
                                          ...this.state.event.styling,
                                          bgImg: null
                                        }
                                      }
                                    }, () => {
                                      this.props.onSave(this.state.event)
                                      window.location.reload()
                                    })
                                  }}
                                    style={{ color: '#FF5244' }}
                                  >
                                    REMOVE
                                  </button>
                                </div> : null
                            }
                          </div>
                        </div>
                        <p><br /></p>
                      </Card>
                      <p><br /></p>
                      <Card>
                        <div style={{ paddingRight: '10%', paddingLeft: '5%', textAlign: 'center' }}>
                          <p />
                          <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Description Media</h3>
                          <Info>Upload an extra image to showcase in the event description on the checkout page.<br />
                            <br />Image size limit: 1MB.</Info>
                          <div style={{ paddingRight: '15%', paddingLeft: '15%' }}>
                            <ImageUpload
                              imgSrc={this.state.event.styling.descripImg}
                              onUpload={imgUrl => {
                                this.setState({
                                  event: {
                                    ...this.state.event,
                                    styling: {
                                      ...this.state.event.styling,
                                      descripImg: imgUrl
                                    }
                                  }
                                });
                                this.props.onSave(this.state.event, true)
                              }}
                              logo={true}
                            />
                            {
                              this.state.event.styling.descripImg !== null && this.state.event.styling.descripImg !== "" ?
                                <div style={{ width: '100%', float: 'right' }}>
                                  <p />
                                  <button className="new-button-white-4" onClick={e => {
                                    this.setState({
                                      event: {
                                        ...this.state.event,
                                        styling: {
                                          ...this.state.event.styling,
                                          descripImg: null
                                        }
                                      }
                                    }, () => {
                                      this.props.onSave(this.state.event)
                                      window.location.reload()
                                    })
                                  }}
                                    style={{ color: '#FF5244' }}
                                  >
                                    REMOVE
                                  </button>
                                </div> : null
                            }
                          </div>
                        </div>
                        <p><br /></p>
                      </Card>
                    </div>
                }
                <p><br /></p>
                <div style={{ width: "100%", minHeight: '75px', paddingRight: '15%', paddingLeft: '15%' }}>
                  <div>
                    <p />
                    <div className="align-center">
                      {this.state.saveSuccessDetail ? <Success content="Settings saved successfully!" /> : null}
                    </div>
                    <div style={{ textAlign: 'center', width: '100%' }}>
                      <div style={{ width: '100%' }}>
                        <button
                          className='new-button-save'
                          onClick={e => {
                            e.preventDefault();
                            const obj = { ...this.state.event, type: true }
                            this.props.onSave(obj);
                          }}
                          disabled={!this.state.isValid || this.state.timeError}
                          style={{ border: 'none' }}
                        >
                          SAVE
                          </button>
                      </div>
                      <OnlyAdmin>
                        <br />
                        <button
                          className="new-button-blue-outline"
                          onClick={(e: any) => openDeleteEventModal(this.state.event.id, this.state.event.name, this.handleRedirect)}
                        // xstyle={{ border: 'none' }}
                        >
                          DELETE
                        </button>
                      </OnlyAdmin>
                    </div>

                  </div>
                  <p />
                </div>
                <p><br /></p>
              </Col>
            </Row>
          </div>
          <div className="small-split-768">
            <Row>
              <Col>
                <Card>
                  <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                    <p />
                    <div style={{ textAlign: 'center' }}>
                      <div>
                        <h3 className="sexyBlack">Basic Information</h3>
                      </div>
                      <div >
                        <p />
                        <ImportEvent eventId={this.props.event.id} />
                      </div>
                    </div>
                    <p />
                    <Text
                      label="Name of event"
                      value={this.state.event.name}
                      name="name"
                      onChange={this.handleInputChange}
                    />
                    <Text
                      label="Host name"
                      value={this.state.event.hostName}
                      name="hostName"
                      onChange={this.handleInputChange}
                    />
                    <div>
                      <Label>
                        Location
                    </Label>
                      <GooglePlacesAutocomplete
                        onSelect={this.handleInputChangeLocation}
                        initialValue={this.state.event.location}
                        placeholder=''
                        inputStyle={{
                          width: '100%',
                          borderRadius: '10px',
                          border: '1px solid #CED4DA',
                          boxShadow: 'none',
                          color: '#495057'
                        }}
                      />
                      <p />
                    </div>
                    <TextArea
                      label="Description"
                      value={this.state.event.description}
                      name="description"
                      onChange={this.handleInputChange}
                    />
                    <p />
                    {
                      this.props.event.isActive === true ?
                        <div>
                          <div style={{ textAlign: 'center', width: '100%' }}>
                            <br />
                            <div>
                              <div style={{ height: '30px', lineHeight: '40px' }}>
                                <Switch
                                  checked={this.state.event.onSale}
                                  onChange={this.changeSale}
                                  onColor="#4d5adf"
                                  onHandleColor="#ffffff"
                                  handleDiameter={25}
                                  uncheckedIcon={false}
                                  checkedIcon={true}
                                  boxShadow="0 2px 1px -1px gray"
                                  height={25}
                                  width={50}
                                  className="react-switch"
                                  id="material-switch"
                                />
                              </div>
                              <div style={{ height: '20px', lineHeight: '20px' }}>Live</div>
                            </div>
                            <FormText color="muted">Event goes on sale if turned on.</FormText>
                          </div>
                          <p />
                        </div> : null
                    }
                  </div>
                  <p />
                </Card>
                {
                  this.props.event.payoutTime === null ?
                    <div>
                      <p><br /></p>
                      <Card>
                        <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
                          <p />
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            <h3 className="sexyBlack">Time Information</h3>
                          </div>
                          <p />
                          <div>
                            <div>
                              <div className="small-split-768">
                                <div style={{ textAlign: 'center' }}>
                                  <div style={{ width: '100%' }}>
                                    <p>Start Time</p>
                                    <DatePicker
                                      selected={this.state.startTime}
                                      onChange={this.handleStartChange}
                                      selectsStart={true}
                                      startDate={this.state.startTime}
                                      endDate={this.state.endTime}
                                      minDate={new Date()}

                                      minTime={flag1 ? new Date() : zero}
                                      maxTime={now}

                                      showTimeSelect={true}
                                      timeFormat="HH:mm"
                                      timeIntervals={15}
                                      dateFormat="MMMM d, yyyy h:mm aa"
                                      timeCaption="time"
                                      style={{ width: '100%' }}
                                    />
                                  </div>
                                  <p />
                                  <div style={{ width: '100%' }}>
                                    <p>End Time</p>
                                    <DatePicker
                                      selected={this.state.endTime}
                                      onChange={this.handleEndChange}
                                      selectsEnd={true}
                                      startDate={this.state.startTime}
                                      endDate={this.state.endTime}
                                      minDate={this.state.startTime}

                                      minTime={flag2 ? new Date() : zero}
                                      maxTime={now}

                                      showTimeSelect={true}
                                      timeFormat="HH:mm"
                                      timeIntervals={15}
                                      dateFormat="MMMM d, yyyy h:mm aa"
                                      timeCaption="time"
                                      style={{ width: '100%' }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div>
                                <p><br /></p>
                                <div style={{ paddingLeft: '10%', paddingRight: '10%' }}>
                                  <TimezoneSelect
                                    onChange={this.handleInputChange}
                                    name="timezoneOffset"
                                    value={this.state.event.timezoneOffset}
                                    label="Time zone"
                                    infoMessage={"Event will no longer be active once it reaches its end time in its time zone."}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p><br /></p>
                      </Card>
                    </div> : null
                }
                <p><br /></p>
                <Card>
                  <div style={{ paddingRight: '15%', paddingLeft: '15%' }}>
                    <p />
                    <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Quotas and Fees</h3>
                    <p />
                    <NumberInput
                      label="Total event quota"
                      infoMessage={
                        "The total number of existing tickets – allocated, offers pending and sold – will not exceed the event quota."
                      }
                      value={this.state.event.configuration === null ? this.getTotalAllocated() : this.state.event.configuration.quota}
                      min={this.getTotalAllocated()}
                      name="quota"
                      onChange={this.handleInputConfigurationsChange}
                    />

                    <NumberInput
                      label="Tax (%)"
                      value={this.state.event.fees == null ? 0 : this.state.event.fees.taxPercentage}
                      min={0}
                      max={100}
                      name="taxPercentage"
                      onChange={this.handleInputFeesChange}
                    />

                    <NumberInput
                      label="Max tickets per order"
                      value={this.state.event.configuration === null ? 1 : this.state.event.configuration.maxTicketsPerOrder}
                      min={-1}
                      name="maxTicketsPerOrder"
                      onChange={this.handleInputConfigurationsChange}
                    />

                    <Select
                      label="Service fee attribution"
                      value={this.state.event.fees.absorb ? "absorb" : "pass"}
                      name="absorb"
                      onChange={this.handleInputBooleanChange}
                      infoMessage={
                        "Passed-on fees are added to the base ticket price for customers to bear. Absorbed fees keep the same base ticket price, but fees are deducted from event revenue.\n*Card processing fees will be added."
                      }
                    >

                      <option value="pass">Pass fees on</option>
                      <option value="absorb">Absorb fees</option>


                    </Select>
                    <OnlyAdmin>
                      <p><br /><br /></p>
                      <h3 className="sexyBlack" style={{ width: '100%', textAlign: 'center' }}>Service Fee</h3>
                      <p />
                      <NumberInput
                        label="Service fee per Ticket ($)"
                        value={this.state.event.fees == null ? 1 : (this.state.event.fees.perTicketFee)}
                        min={0}
                        name="perTicketFee"
                        onChange={this.handleInputFeesChange}
                      />
                      <NumberInput
                        label="Service fee per Order (%)"
                        value={this.state.event.fees == null ? 0 : this.state.event.fees.perOrderFee}
                        min={0}
                        name="perOrderFee"
                        onChange={this.handleInputFeesChange}
                      />

                      <p />
                    </OnlyAdmin>
                    <p />
                    <div className="align-center" style={{ width: "100%" }}>
                      {this.state.saveSuccessConfig ? <Success content="Settings saved successfully!" /> : null}
                      {!this.state.isValid ? (
                        <div className='alert alert-danger'>
                          Event quota must be greater than or equal to the total number of allocated tickets ({this.getTotalAllocated()})
                        </div>
                      ) : (
                          null
                        )}
                    </div>

                  </div>
                </Card>
                <p><br /></p>
                <div style={{ width: "100%", minHeight: '75px', paddingRight: '15%', paddingLeft: '15%' }}>
                  <div>
                    <p />
                    <div className="align-center">
                      {this.state.saveSuccessDetail ? <Success content="Settings saved successfully!" /> : null}
                    </div>
                    <div style={{ textAlign: 'center', width: '100%' }}>
                      <div style={{ width: '100%' }}>
                        <button
                          className='new-button-save'
                          onClick={e => {
                            e.preventDefault();
                            const obj = { ...this.state.event, type: true }
                            this.props.onSave(obj);
                          }}
                          disabled={!this.state.isValid || this.state.timeError}
                          style={{ border: 'none' }}
                        >
                          SAVE
                          </button>
                      </div>
                      <OnlyAdmin>
                        <br />
                        <button
                          className="new-button-blue-outline"
                          onClick={(e: any) => openDeleteEventModal(this.state.event.id, this.state.event.name, this.handleRedirect)}
                        >
                          DELETE
                        </button>
                      </OnlyAdmin>
                    </div>
                  </div>
                  <p />
                </div>
                <p><br /></p>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }

  public getTeamUsers(): any {
    const users = {};
    if (
      this.state.event.promoters !== undefined &&
      this.state.event.promoters !== null &&
      this.state.event.promoters.length > 0
    ) {
      this.state.event.promoters.forEach(item => {
        users[item] = item;
      });
    }

    if (this.state.event.hosts !== undefined &&
      this.state.event.hosts !== null &&
      this.state.event.hosts.length > 0) {
      this.state.event.hosts.forEach(item => {
        users[item] = item;
      });
    }

    if (
      this.state.event.checkers !== undefined &&
      this.state.event.checkers !== null &&
      this.state.event.checkers.length > 0
    ) {
      this.state.event.checkers.forEach(item => {
        users[item] = item;
      });
    }

    return users;
  }

  public renderTeamItemRole(item) {
    let role = "";
    if (
      this.state.event.hosts &&
      this.state.event.hosts.indexOf(item.id) > -1
    ) {
      role = RolesSystem.HOST;
    } else if (
      this.state.event.promoters &&
      this.state.event.promoters.indexOf(item.id) > -1
    ) {
      role = RolesSystem.PROMOTER;
    } else if (
      this.state.event.checkers &&
      this.state.event.checkers.indexOf(item.id) > -1
    ) {
      role = RolesSystem.CHECKER;
    }

    if (this.state.event.createdBy && this.state.event.createdBy === item.id) {
      return <b>Owner</b>;
    }

    return (
      <Select
        noMargin={true}
        value={role}
        onChange={(e: any) => {
          this.props.onChangeUserRole(item.id, e.target.value);
        }}
      >
        {Object.keys(RolesSystemReverse).map(key => {
          if (key === RolesSystem.NOT_LOGGEDIN && this.state.event.hosts.length === 1 && role === RolesSystem.HOST) {
            return (
              <OnlyAdmin>
                <option key={"role-select-item--" + key} value={key}>
                  {RolesSystemReverse[key]}
                </option>
              </OnlyAdmin>
            );
          } else {
            return (
              <option key={"role-select-item--" + key} value={key}>
                {RolesSystemReverse[key]}
              </option>
            );
          }
        })}
      </Select>
    );
  }

  public renderTeamTab() {
    return (
      <div>
        <div>
          <Row>
            <Col>
              <Card>
                <div>
                  <p />
                  <h3 className="sexyBlack" style={{ textAlign: 'center' }}>Add Team Member</h3>
                  <p />
                  <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                    <TextArea
                      label={"E-mail"}
                      name="emails"
                      value={this.state.newUser.emails}
                      onChange={this.handleTeamNewUserChange}
                      infoMessage={
                        "One e-mail per line. For Facebook or Google please input their registration e-mail."
                      }
                    />
                    <Select
                      label={"Role"}
                      name="role"
                      onChange={this.handleTeamNewUserChange}
                    >
                      <option value={RolesSystem.PROMOTER} selected={true}>Promoter</option>
                      <option value={RolesSystem.CHECKER}>Ticket Scanner</option>
                      <option value={RolesSystem.HOST}>Host</option>
                    </Select>
                    <div>
                      {
                        this.state.invalidTeamFormatError ?
                          <Error content="Please only enter correct emails, one email per line, no duplicates" />
                          : null
                      }
                    </div>
                    <div className="w-100 text-right">
                      <button onClick={this.handleAddUsers}
                        disabled={this.state.newUser.emails !== null && this.state.newUser.emails !== '' ? false : true}
                        className="new-button-blue-gradient" style={{ border: 'none' }}>+</button>
                    </div>
                    <p />
                  </div>
                </div>
                <p />
              </Card>
              <p><br /></p>
            </Col>
            <Col>
              <Card style={{ textAlign: 'center' }}>
                <p />
                <h3 className="sexyBlack">Team</h3>
                <p />
                <div style={{ overflowX: 'scroll', overflowY: 'scroll', maxHeight: '600px' }}>
                  <table className="table-responsive--base" style={{ minWidth: '700px' }}>
                    <thead>
                      <tr>
                        <td>NAME</td>
                        <td>EMAIL</td>
                        <td>LAST ACTIVE</td>
                        <td>ROLE</td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderTeamUsers().map(userItem => {
                        if (userItem.email.includes('@isotope-referral-code.com')) {
                          return null
                        }
                        return (
                          <tr key={"user-" + userItem.id}>
                            <td data-label={"Full name"} className="sexyBlack">
                              {userItem.name} {userItem.lastname}
                            </td>
                            <td data-label={"E-mail"}>{userItem.email}</td>
                            <td data-label={"Last Active"}>
                              {userItem.lastLoginAt ? (
                                <Moment fromNow={true}>{Number(new Date(userItem.lastLoginAt))}</Moment>
                              ) : (
                                  '-'
                                )}
                            </td>
                            <td data-label={"Role"}>
                              {this.renderTeamItemRole(userItem)}
                            </td>
                          </tr>
                        );
                      })}
                      {this.renderTeamUsers().length === 0 ? (
                        <tr>
                          <td colSpan={3} className="text-center p-2">
                            {" "}
                            No users in team.
                  </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
                <p />
              </Card>
              <p><br /></p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  public renderReferralCodesTab() {
    return (
      <div>
        <div>
          <Row>
            <Col>
              <Card>
                <div>
                  <p />
                  <h3 className="sexyBlack" style={{ textAlign: 'center' }}>Add Referral Code</h3>
                  <p />
                  <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                    <TextArea
                      label={"Enter Codes"}
                      name="emails"
                      value={this.state.newUser.emails}
                      onChange={this.handleTeamNewUserChange}
                      infoMessage={
                        "One code per line. A unique referral link will be created and associated to each code entered."
                      }
                    />
                    <div>
                      {
                        this.state.invalidTeamFormatError ?
                          <Error content="Please only enter correct emails, one email per line, no duplicates" />
                          : null
                      }
                    </div>
                    <div className="w-100 text-right">
                      <button onClick={this.handleAddCodes}
                        disabled={this.state.newUser.emails !== null && this.state.newUser.emails !== '' ? false : true}
                        className="new-button-blue-gradient" style={{ border: 'none' }}>+</button>
                    </div>
                    <p />
                  </div>
                </div>
                <p />
              </Card>
              <p><br /></p>
            </Col>
            <Col>
              <Card style={{ textAlign: 'center' }}>
                <p />
                <h3 className="sexyBlack">Referral Links</h3>
                <p />
                <div style={{ overflowX: 'scroll', overflowY: 'scroll', maxHeight: '600px' }}>
                  <table className="table-responsive--base" style={{ minWidth: '700px' }}>
                    <thead>
                      <tr>
                        <td>CODE</td>
                        <td>LINK</td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderTeamUsers().map(userItem => {
                        if (!userItem.email.includes('@isotope-referral-code.com')) {
                          return null
                        }
                        let link = ''
                        const subdomain = this.state.urlObject.customSubdomain
                        if (subdomain !== undefined &&
                          subdomain !== null &&
                          subdomain !== ''
                        ) {
                          link = 'https://' + subdomain + '.isotopeticketing.com/' + userItem.email.split('@')[0]
                        } else {
                          const u = this.state.urlObject.teamMap.find((item) => {
                            return item.userId === userItem.id
                          })
                          link = 'http://istkt.com/event-' + this.state.urlObject.code + '-' + u.index
                        }
                        return (
                          <tr key={"user-" + userItem.id}>
                            <td data-label={"Full name"} className="sexyBlack">
                              {userItem.name} {userItem.lastname}
                            </td>
                            <td data-label={"E-mail"}>
                              <a href={link} target="_blank" style={{ width: '100%', textAlign: 'center', cursor: 'pointer' }}>
                                {link.split('://')[1]}
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                      {this.renderTeamUsers().length === 0 ? (
                        <tr>
                          <td colSpan={3} className="text-center p-2">
                            {" "}
                            No referral codes in team.
                  </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
                <p />
              </Card>
              <p><br /></p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  public renderAnnouncementsTab() {
    return <div style={{ paddingRight: screen.width > 768 ? '25%' : '5%', paddingLeft: screen.width > 768 ? '25%' : '5%' }}>
      <Card>
        <div>
          <p />
          <h3 className="sexyBlack" style={{ textAlign: 'center' }}><p />Email team</h3>
          <p />
          <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
            <TextArea
              label={"Message"}
              name="emails"
              value={this.state.messageToTeam}
              onChange={e => this.teamMessageChange(e, 'team')}
              infoMessage={
                "Any message typed here will be emailed to all team members."
              }
            />
            <div className="w-100 text-right">
              <button
                onClick={this.sendMessagetoTeam}
                className="new-button-white-3" style={{ border: 'none' }}>SEND</button>
            </div>
            <p />
            {
              this.state.emailSuccess0 ? <Success content="Message has been sent!" /> : null
            }
            {
              this.state.emailError0 ? <Error content="An unknown error occurred" /> : null
            }
            <p />
          </div>
        </div>
        <p />
      </Card>
      <p><br /></p>
      <Card>
        <div>
          <p />
          <h3 className="sexyBlack" style={{ textAlign: 'center' }}><p />Email all ticket buyers</h3>
          <p />
          <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
            <TextArea
              label={"Message"}
              name="emails"
              value={this.state.messageToBuyers}
              onChange={e => this.teamMessageChange(e, 'buyers')}
              infoMessage={
                "Any message typed here will be emailed to all ticket buyers (free/paid)."
              }
            />
            <div className="w-100 text-right">
              <button
                onClick={this.sendMessagetoBuyers}
                className="new-button-white-3" style={{ border: 'none' }}>SEND</button>
            </div>
            <p />
            {
              this.state.emailSuccess1 ? <Success content="Message has been sent!" /> : null
            }
            {
              this.state.emailError1 ? <Error content="An unknown error occurred" /> : null
            }
            <p />
          </div>
        </div>
        <p />
      </Card>
      <p><br /></p>
      <Card>
        <div>
          <p />
          <h3 className="sexyBlack" style={{ textAlign: 'center', paddingLeft: '5%', paddingRight: '5%' }}><p />Email all prospects who were emailed offers</h3>
          <p />
          <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
            <TextArea
              label={"Message"}
              name="emails"
              value={this.state.messageToPotentialBuyers}
              onChange={e => this.teamMessageChange(e, 'potentialBuyers')}
              infoMessage={
                "Any message typed here will be emailed to potential customers who were emailed private offers directly after creation."
              }
            />
            <div className="w-100 text-right">
              <button
                onClick={this.sendMessagetoPotentialBuyers}
                className="new-button-white-3" style={{ border: 'none' }}>SEND</button>
            </div>
            <p />
            {
              this.state.emailSuccess2 ? <Success content="Message has been sent!" /> : null
            }
            {
              this.state.emailError2 ? <Error content="An unknown error occurred" /> : null
            }
            <p />
          </div>
        </div>
        <p />
      </Card>
      <p><br /></p>
      <Card>
        <div>
          <p />
          <h3 className="sexyBlack" style={{ textAlign: 'center', paddingLeft: '5%', paddingRight: '5%' }}><p />
            Email team their referral links along with a message
          </h3>
          <p />
          <div style={{ paddingRight: '5%', paddingLeft: '5%' }}>
            <TextArea
              label={"Message"}
              name="emails"
              value={this.state.messageToReferralLinkUsers}
              onChange={e => this.teamMessageChange(e, 'referralLinkUsers')}
              infoMessage={
                "Any message typed here will be emailed to your team along with their referral links."
              }
            />
            <div className="w-100 text-right">
              <button
                onClick={this.sendReferralLinksWithAMessage}
                className="new-button-white-3" style={{ border: 'none' }}>SEND</button>
            </div>
            <p />
            {
              this.state.emailSuccess3 ? <Success content="Message has been sent!" /> : null
            }
            {
              this.state.emailError3 ? <Error content="An unknown error occurred" /> : null
            }
            <p />
          </div>
        </div>
        <p />
      </Card>
      <p><br /></p>
    </div>
  }

  public renderReferralsTab() {
    return (
      <div>
        <ReferralTicketInventory
          ticketInventory={this.props.ticketInventory}
          hosts={this.props.event.hosts}
          promoters={this.props.event.promoters}
          eventId={this.props.event.id}
          capacity={this.props.event.configuration.quota}
          currency={this.props.event.currency ? this.props.event.currency : 'USD'}
        />
      </div>
    );
  }

  public renderTeamUsers() {
    const users: any = this.getTeamUsers();
    const usersMap: any = this.props.users;
    const res: any[] = [];
    for (const key in users) {
      if (usersMap[key]) {
        res.push(usersMap[key]);
      }
    }
    return res;
  }

  public renderPromptOnLeave() {
    return (
      <Prompt
        when={this.state.isChanged}
        message={`Do you want to leave this page without saving your changes ?`}
      />
    );
  }
  public render() {

    const tab = this.props.tabName || "details";
    let content: any = null;
    switch (tab) {
      case "team":
        content = this.renderTeamTab();
        break;
      case "announcements":
        content = this.renderAnnouncementsTab();
        break;
      // case "referrals":
      //   content = this.renderReferralsTab();
      //   break;
      case "referral-codes":
        // Cause we want the URL object first
        if (this.state.loading) {
          return null;
        }
        content = this.renderReferralCodesTab();
        break;
      case "publicTickets":
        content = (
          <div>
            <PublicTicketInventoryTab
              ticketInventory={this.props.ticketInventory}
              promoters={this.props.event.promoters}
              eventId={this.props.event.id}
              capacity={this.props.event.configuration.quota}
              currency={this.props.event.currency ? this.props.event.currency : 'USD'}
            /></div>
        );
        break;
      case "privateTickets":
        content = (
          <div>
            <PrivateTicketInventoryTab
              ticketInventory={this.props.ticketInventory}
              promoters={this.props.event.promoters}
              hosts={this.props.event.hosts}
              eventId={this.props.event.id}
              capacity={this.props.event.configuration.quota}
              currency={this.props.event.currency ? this.props.event.currency : 'USD'}
            /></div>
        );
        break;
      default:
        content = this.renderDetailsTab();
        break;
    }
    return (
      <div>
        {this.renderPromptOnLeave()}
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/edit.form.tsx